/** Editor presets; existing three strings remain byte-identical for saved audio. */
export const EMOTIONAL_INTENSITIES=['Subtle emotion','Mild emotion','Moderate emotion','Heightened emotion','Strong emotion'] as const;
/** Listening-oriented order, not a claim that vocal styles form a physical scale.
 * Applied only on an explicit style edit; never migrate existing annotations. */
export const DELIVERY_ENERGY = [
  ['Monotone',0],['Deadpan',0],['Whispering',0],['Weary',0],
  ['Muttering',1],['Calm',1],['Gentle',1],['Hesitant',1],
  ['Conversational',2],['Deliberate',2],
  ['Trembling',3],['Crying while speaking',3],['Out of breath',3],['Laughing while speaking',3],['Animated',3],
  ['Urgent',4],['Forceful',4],['Shouting',4],
] as const;
export function deliveryStylePatch(delivery:string){
  const preset=DELIVERY_ENERGY.find(([name])=>name===delivery);
  if(!preset&&delivery)throw new Error('Unknown delivery style.');
  return {delivery:delivery||undefined,intensity:preset?EMOTIONAL_INTENSITIES[preset[1]]:undefined,deliveryStrength:undefined};
}
export const DELIVERY_FAMILIES = [
  { id: "steady", name: "Steady & restrained", presets: ["Conversational", "Calm", "Gentle", "Deliberate", "Deadpan", "Monotone"] },
  { id: "energy", name: "Energy & force", presets: ["Animated", "Urgent", "Forceful", "Shouting"] },
  { id: "strain", name: "Strain & uncertainty", presets: ["Out of breath", "Weary", "Hesitant", "Trembling"] },
  { id: "expression", name: "Vocal expression", presets: ["Whispering", "Muttering", "Laughing while speaking", "Crying while speaking"] },
] as const;

/** Browsing groups, not restrictions on previously saved emotion combinations. */
export const EMOTION_SUBTLE_FAMILIES: Record<string, readonly string[]> = {
  Neutral: ['Matter-of-fact', 'Sincere', 'Respectful', 'Authoritative', 'Persuasive', 'Ironic'],
  Happy: ['Amused', 'Excited', 'Hopeful', 'Proud', 'Grateful', 'Relieved', 'Tender', 'Reassuring', 'Affectionate', 'Confident', 'Playful'],
  Sad: ['Disappointed', 'Lonely', 'Nostalgic', 'Guilty', 'Embarrassed', 'Tender', 'Apologetic'],
  Angry: ['Frustrated', 'Resentful', 'Jealous', 'Determined', 'Sarcastic', 'Threatening', 'Defiant', 'Condescending'],
  Afraid: ['Anxious', 'Nervous', 'Apprehensive', 'Vulnerable', 'Suspicious'],
  Disgusted: ['Resentful', 'Guilty', 'Disappointed', 'Skeptical', 'Dismissive', 'Sarcastic'],
  Surprised: ['Curious', 'Confused', 'Excited', 'Skeptical'],
};
